// 智能价格格式化函数（根据店铺货币自动适配）
function formatPrice(priceInCents) {
    const price = priceInCents / 100;
    const currency = window.mtCustomProductData?.currencyCode || 'USD'; // 获取当前货币代码
    const country = window.mtCustomProductData?.countryCode || 'US'; // 获取当前国家代码

    // 根据货币和国家确定合适的地区格式
    let locale = 'en-US'; // 默认格式

    if (currency === 'EUR') {
        if (country === 'DE') locale = 'de-DE';
        else if (country === 'FR') locale = 'fr-FR';
        else if (country === 'ES') locale = 'es-ES';
        else if (country === 'IT') locale = 'it-IT';
        else locale = 'en-EU'; // 默认欧元格式
    } else if (currency === 'GBP') {
        locale = 'en-GB';
    } else if (currency === 'JPY') {
        locale = 'ja-JP';
    } else if (currency === 'CNY') {
        locale = 'zh-CN';
    } else if (currency === 'CAD') {
        locale = 'en-CA';
    } else if (currency === 'AUD') {
        locale = 'en-AU';
    }

    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
    }).format(price);
}

function getDataAttr(el, keys) {
    if (!el) return null;
    var list = Array.isArray(keys) ? keys : [keys];
    for (var i = 0; i < list.length; i++) {
        var k = list[i];
        if (!k) continue;
        // dataset key (e.g. "imageId", "variantId")
        if (el.dataset && el.dataset[k] != null && el.dataset[k] !== '') return el.dataset[k];
        // attribute key (e.g. "data-image-id", "data_image_id")
        if (el.getAttribute) {
            var v = el.getAttribute(k);
            if (v != null && v !== '') return v;
        }
    }
    return null;
}

// Service List Functions - 移到全局作用域
function openServiceModal(blockId) {
    var modal = document.getElementById('mt-service-modal-' + blockId);
    if (modal) {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
    }
}

function closeServiceModal(blockId) {
    var modal = document.getElementById('mt-service-modal-' + blockId);
    if (modal) {
        modal.classList.remove('active');
        document.body.style.overflow = '';
    }
}

// 添加点击弹窗背景关闭弹窗的功能
document.addEventListener('DOMContentLoaded', function () {
    // 为所有service modal添加背景点击关闭功能
    var serviceModals = document.querySelectorAll('.mt-service-modal');
    serviceModals.forEach(function (modal) {
        modal.addEventListener('click', function (e) {
            // 如果点击的是弹窗背景（不是弹窗内容），则关闭弹窗
            if (e.target === modal) {
                var blockId = modal.id.replace('mt-service-modal-', '');
                closeServiceModal(blockId);
            }
        });
    });

    // 添加ESC键关闭弹窗功能
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            var activeModal = document.querySelector('.mt-service-modal.active');
            if (activeModal) {
                var blockId = activeModal.id.replace('mt-service-modal-', '');
                closeServiceModal(blockId);
            }
        }
    });
});

function hoverServiceItem(el, blockId, isHover) {
    var img = el.querySelector('.mt-service-icon img');
    if (img) {
        if (isHover) {
            var hoverSrc = img.getAttribute('data-hover');
            if (hoverSrc) {
                img.src = hoverSrc;
            }
            el.classList.add('active');
        } else {
            var defaultSrc = img.getAttribute('data-default');
            if (defaultSrc) {
                img.src = defaultSrc;
            }
            el.classList.remove('active');
        }
    }
}

// 滚动到选中的缩略图（全局函数，可在任何地方调用）
function scrollToThumbnail(activeThumb, thumbsWrapper) {
    // 如果没有提供 thumbsWrapper，尝试从 activeThumb 的父元素中查找
    if (!thumbsWrapper && activeThumb) {
        var container = activeThumb.closest('.mt-custom-product-container');
        if (container) {
            thumbsWrapper = container.querySelector('.mt-custom-product-gallery-thumbs');
        }
        // 如果还是找不到，尝试直接查找
        if (!thumbsWrapper) {
            thumbsWrapper = document.querySelector('.mt-custom-product-gallery-thumbs');
        }
    }
    
    if (!thumbsWrapper || !activeThumb) {
        console.warn('[scrollToThumbnail] 缺少必要参数 - thumbsWrapper:', !!thumbsWrapper, 'activeThumb:', !!activeThumb);
        return;
    }
    
    // 检查缩略图容器的排列方向（垂直或水平）
    var computedStyle = window.getComputedStyle(thumbsWrapper);
    var flexDirection = computedStyle.flexDirection;
    var isVertical = flexDirection === 'column' || flexDirection === 'column-reverse';
    
    
    var wrapperRect = thumbsWrapper.getBoundingClientRect();
    var thumbRect = activeThumb.getBoundingClientRect();

    // 根据排列方向检查缩略图是否在可视区域内
    var isVisible;
    if (isVertical) {
        // 垂直排列：检查 top 和 bottom
        isVisible = (
            thumbRect.top >= wrapperRect.top &&
            thumbRect.bottom <= wrapperRect.bottom
        );
    } else {
        // 水平排列：检查 left 和 right
        isVisible = (
            thumbRect.left >= wrapperRect.left &&
            thumbRect.right <= wrapperRect.right
        );
    }

    if (isVertical) {
        // 垂直滚动：计算需要滚动的距离
        var scrollTop = activeThumb.offsetTop - (thumbsWrapper.clientHeight / 2) + (activeThumb.offsetHeight / 2);

        // 确保滚动位置在合理范围内
        scrollTop = Math.max(0, Math.min(scrollTop, thumbsWrapper.scrollHeight - thumbsWrapper.clientHeight));

        // 平滑滚动到目标位置
        thumbsWrapper.scrollTo({
            top: scrollTop,
            behavior: 'smooth'
        });
    } else {
        // 水平滚动
        var scrollLeft;
        var isMobile = window.innerWidth < 990;

        if (isMobile) {
            // M 端：按缩略图宽度的整数倍对齐
            var computed = window.getComputedStyle(thumbsWrapper);
            var gap = parseFloat(computed.columnGap || computed.gap || 0);
            var itemWidth = activeThumb.offsetWidth + (isNaN(gap) ? 0 : gap);
            if (itemWidth > 0) {
                var rawLeft = activeThumb.offsetLeft;
                var stepIndex = Math.round(rawLeft / itemWidth);
                scrollLeft = stepIndex * itemWidth;
            } else {
                // 兜底：回退到原来的居中逻辑
                scrollLeft = activeThumb.offsetLeft - (thumbsWrapper.clientWidth / 2) + (activeThumb.offsetHeight / 2);
            }
        } else {
            // 非 M 端维持原来的居中逻辑
            scrollLeft = activeThumb.offsetLeft - (thumbsWrapper.clientWidth / 2) + (activeThumb.offsetWidth / 2);
        }

        // 确保滚动位置在合理范围内
        scrollLeft = Math.max(0, Math.min(scrollLeft, thumbsWrapper.scrollWidth - thumbsWrapper.clientWidth));

        // 平滑滚动到目标位置
        thumbsWrapper.scrollTo({
            left: scrollLeft,
            behavior: 'smooth'
        });
    } 
}

document.addEventListener('DOMContentLoaded', function () {
    // 从全局变量获取数据
    var productData = window.mtCustomProductData?.product;
    var productId = window.mtCustomProductData?.productId;
    var variantInventoryMap = window.mtCustomProductData?.variantInventoryMap || {};

    console.log('[mt-product] DOMContentLoaded', {
        hasProductData: !!productData,
        productId: productId,
        hasMtCustomProductData: !!window.mtCustomProductData
    });
    
    if (!productData || !productId) {
        console.error('mtCustomProductData is not available');
        return;
    }
    
    var container = document.getElementById('mt-custom-product-' + productId);
    if (!container) {
        console.error('Product container not found');
        return;
    }
    
    var slider = container.querySelector('.mt-custom-product-gallery-slider');
    var thumbs = container.querySelectorAll('.mt-custom-product-gallery-thumbs img');
    var thumbsWrapper = container.querySelector('.mt-custom-product-gallery-thumbs');
    var leftBtn = container.querySelector('.mt-custom-product-gallery-nav.left');
    var rightBtn = container.querySelector('.mt-custom-product-gallery-nav.right');
    var optionGroups = container.querySelectorAll('.mt-custom-product-options');
    // 只操作主商品表单里的变体 hidden input，避免误选 tying-products 里的 input[name="id"]
    var variantIdInput = container.querySelector('#variant-id-' + productId) 
      || container.querySelector('.product-form input[name="id"]');
    var atcBtn = container.querySelector('.mt-custom-product-atc-btn');
    var atcBtnText = atcBtn ? atcBtn.querySelector('.mt-atc-button-text') : null;
    var soldOutText = (window.variantStrings && window.variantStrings.soldOut) || 'Sold Out';
    var defaultAtcText = atcBtnText ? atcBtnText.textContent.trim() : '';
    if (!defaultAtcText || defaultAtcText === soldOutText) {
        defaultAtcText = (window.variantStrings && window.variantStrings.addToCart) || defaultAtcText || 'Add to cart';
    }

    function normalizeOptionValue(value) {
        return (value == null ? '' : String(value)).trim();
    }

    function buildVariantOptionsKey(options) {
        return (options || []).map(normalizeOptionValue).join('|||');
    }

    function isVariantPurchasable(variant) {
        return Boolean(variant && variant.available);
    }

    function findVariantByOptions(selectedOptions) {
        if (!selectedOptions.length && productData.variants.length === 1) {
            return productData.variants[0];
        }
        var key = buildVariantOptionsKey(selectedOptions);
        return productData.variants.find(function (variant) {
            return buildVariantOptionsKey(variant.options) === key;
        });
    }

    function syncHiddenOptionsFromModals() {
        optionGroups.forEach(function (group, optionIndex) {
            var modal = document.getElementById('mt-option-modal-' + optionIndex);
            if (!modal) return;
            var checked = modal.querySelector('input[type="radio"]:checked');
            if (!checked) return;
            var selectedValue = checked.value;
            var normalizedSelected = normalizeOptionValue(selectedValue);
            group.querySelectorAll('.mt-custom-product-option-value').forEach(function (v) {
                v.classList.remove('selected');
                if (normalizeOptionValue(v.dataset.value) === normalizedSelected) {
                    v.classList.add('selected');
                }
            });
            var desc = group.querySelector('.mt-option-desc');
            if (desc) desc.textContent = selectedValue;
        });
    }

    function findModalRadio(modal, value) {
        if (!modal) return null;
        var normalized = normalizeOptionValue(value);
        var radios = modal.querySelectorAll('input[type="radio"]');
        for (var i = 0; i < radios.length; i++) {
            if (normalizeOptionValue(radios[i].value) === normalized) {
                return radios[i];
            }
        }
        return null;
    }

    // 从 URL 读取变体参数（优先 variantId，兼容 Shopify 原生 variant）
    function getVariantIdFromUrl() {
        try {
            var params = new URLSearchParams(window.location.search);
            return params.get('variantId') || params.get('variant');
        } catch (e) {
            return null;
        }
    }

    // 切换变体时把 variantId 写入地址栏（不刷新页面）
    function updateUrlVariant(variantId) {
        if (!variantId) return;
        try {
            var url = new URL(window.location.href);
            url.searchParams.set('variantId', String(variantId));
            // 若存在原生 variant 参数，一并同步，避免两个参数指向不同变体
            if (url.searchParams.has('variant')) {
                url.searchParams.set('variant', String(variantId));
            }
            window.history.replaceState({}, '', url.toString());
        } catch (e) {
            try {
                window.history.replaceState({}, '', window.location.pathname + '?variantId=' + encodeURIComponent(variantId));
            } catch (err) {}
        }
    }

    function getSelectedOptions() {
        var selectedOptions = [];
        optionGroups.forEach(function (group) {
            var selected = group.querySelector('.mt-custom-product-option-value.selected');
            selectedOptions.push(normalizeOptionValue(selected ? selected.dataset.value : ''));
        });
        return selectedOptions;
    }

    var priceEl = container.querySelector('#price-' + productId);
    var oldPriceEl = container.querySelector('#old-price-' + productId);
    var saveEl = container.querySelector('#save-' + productId);
    var stockEl = container.querySelector('#mt-stock-' + productId);
    var inventoryStatusEls = container.querySelectorAll('[data-inventory-status]');
    var qtyInput = container.querySelector('.mt-custom-product-qty');
    var minusBtn = container.querySelector('.mt-custom-product-qty-btn.minus');
    var plusBtn = container.querySelector('.mt-custom-product-qty-btn.plus');
    var modal = container.querySelector('#mt-image-modal-' + productId);
    var modalSlider = container.querySelector('#mt-modal-slider-' + productId);
    var modalSlides = modalSlider ? Array.from(modalSlider.querySelectorAll('.mt-modal-image-slide')) : [];
    var closeModalBtn = container.querySelector('.mt-custom-product-image-modal-close');
    var closeModalBtn3 = container.querySelector('.mt-custom-product-image-modal-close-m');
    var closeModalBtn2 = null; // modal 图片不再用单图点击关闭（避免误触滑动）
    var modalNavLeft = container.querySelector('.mt-modal-nav-left');
    var modalNavRight = container.querySelector('.mt-modal-nav-right');
    var expressPic = container.querySelector('.mt-express-pic');

    function updateInventoryStatus(variant) {
        inventoryStatusEls.forEach(function (statusEl) {
            var isInStock = Boolean(variant && variant.available);
            var label = isInStock ? statusEl.dataset.inStockLabel : statusEl.dataset.outOfStockLabel;
            var labelEl = statusEl.querySelector('[data-inventory-status-label]');

            statusEl.classList.toggle('is-unavailable', !isInStock);
            statusEl.setAttribute('aria-label', label);
            if (labelEl) labelEl.textContent = label;
        });
    }
    var isInitializing = true; // 添加初始化标志
    var urlSyncEnabled = false; // 初始化完成后才允许把变体写入 URL，避免页面加载时污染地址栏
    var syncGalleryWithVariant = false; // 仅用户主动切换 SKU 后才同步变体图

    // ===== 调试输出：页面刷新时打印主商品 & 第一个 tying-product 的默认变体 =====
    try {
        // 主商品默认变体（Shopify 传入的 selected_or_first_available_variant）
        var mainDefaultVariant = (window.mtCustomProductData && window.mtCustomProductData.product && window.mtCustomProductData.product.selected_or_first_available_variant) || null;
        if (mainDefaultVariant) {
            console.log(
                '[main-product][default]',
                'variant id:',
                mainDefaultVariant.id,
                'name:',
                mainDefaultVariant.name || mainDefaultVariant.title || window.mtCustomProductData.product.title
            );
        } else {
            console.log('[main-product][default] no selected_or_first_available_variant');
        }

        // 当前商品容器下的第一个 tying-product 默认变体
        var tyingWrapper = container.querySelector('.tying-products__wrapper');
        if (tyingWrapper) {
            var firstTyingForm = tyingWrapper.querySelector('.tying-product form');
            if (firstTyingForm) {
                var tyingIdInput = firstTyingForm.querySelector('input[name="id"]');
                var tyingVariantId = tyingIdInput ? tyingIdInput.value : null;
                var tyingNameEl = firstTyingForm.querySelector('.tying-product__name');
                var tyingDisplayName = tyingNameEl ? tyingNameEl.textContent.trim() : '';

                console.log(
                    '[tying-product][default]',
                    'variant id:',
                    tyingVariantId,
                    'name:',
                    tyingDisplayName
                );
            } else {
                console.log('[tying-product][default] no tying-product form found in current container');
            }
        } else {
            console.log('[tying-product][default] no tying-products__wrapper in current container');
        }
    } catch (e) {
        console.warn('[mt-product] default variant debug failed:', e);
    }

// 简化的图片URL处理 - 直接使用原图，让浏览器和CDN自动优化
function getLargeImageUrl(thumbSrc) {
    // 移除尺寸后缀，使用原图
    return thumbSrc.replace(/[_-]\d+x\./, '.');
}

thumbs.forEach(function (thumb, index) {
    thumb.addEventListener('click', function () {
        
        // 先更新缩略图选中状态
        thumbs.forEach(t => t.parentElement.classList.remove('active'));
        thumb.parentElement.classList.add('active');

        // 然后切换主图
        changeMainImageWithSlide(slider, index);


        // 检查是否有变体ID关联，如果有则更新变体选择
        var variantId = getDataAttr(thumb, ['variantId', 'data-variant-id', 'data_variant_id']);
        if (variantId) {
            var matchingVariant = productData.variants.find(function (variant) {
                return variant.id == variantId;
            });

            if (matchingVariant) {
                // 更新变体选择
                updateVariantSelectionFromImage(matchingVariant);
            }
        } else {
            // 如果没有变体ID，则检查是否有变体使用这张图片
            var largeImageSrc = getLargeImageUrl(thumb.src);
            var matchingVariant = productData.variants.find(function (variant) {
                return variant.featured_image && getLargeImageUrl(variant.featured_image.src) === largeImageSrc;
            });

            if (matchingVariant) {
                // 更新变体选择
                updateVariantSelectionFromImage(matchingVariant);
            }
        }
    });
});

function updateThumbNav() {
    // 获取当前选中的缩略图索引
    var activeThumb = container.querySelector('.mt-custom-product-gallery-thumbs .active');
    var currentIndex = 0;
    if (activeThumb) {
        var thumbsArr = Array.from(thumbs);
        currentIndex = thumbsArr.indexOf(activeThumb.querySelector('img'));
        if (currentIndex < 0) currentIndex = 0;
    }

    // 更新按钮状态
    leftBtn.disabled = currentIndex <= 0;
    rightBtn.disabled = currentIndex >= thumbs.length - 1;

    // 更新按钮背景样式
    if (currentIndex <= 0) {
        leftBtn.style.background = "#FBFAF8";
        leftBtn.querySelector('svg').style.color='#E2DBD3'
    } else {
        leftBtn.style.background = "#E2DBD3";
        leftBtn.querySelector('svg').style.color='#333'

    }

    if (currentIndex >= thumbs.length - 1) {
        rightBtn.style.background = "#FBFAF8";
        rightBtn.querySelector('svg').style.color='#E2DBD3'

    } else {
        rightBtn.style.background = "#E2DBD3";
        rightBtn.querySelector('svg').style.color='#333'

    }
}

leftBtn.addEventListener('click', function () {
    // 获取当前选中的缩略图索引
    var activeThumb = container.querySelector('.mt-custom-product-gallery-thumbs .active');
    var currentIndex = 0;
    if (activeThumb) {
        var thumbsArr = Array.from(thumbs);
        currentIndex = thumbsArr.indexOf(activeThumb.querySelector('img'));
        if (currentIndex < 0) currentIndex = 0;
    }

    // 切换到前一个缩略图
    if (currentIndex > 0) {
        var prevIndex = currentIndex - 1;
        var prevThumb = thumbs[prevIndex];

        // 更新缩略图选中状态
        thumbs.forEach(t => t.parentElement.classList.remove('active'));
        prevThumb.parentElement.classList.add('active');

        // 切换主图
        changeMainImageWithSlide(slider, prevIndex);

        // 滚动到选中的缩略图（changeMainImageWithSlide 已经处理了，这里可以省略）
        // scrollToThumbnail(prevThumb.parentElement, thumbsWrapper);

        // 更新按钮状态（changeMainImageWithSlide 已经处理了，这里可以省略）
        // updateThumbNav();
    }
});

rightBtn.addEventListener('click', function () {
    // 获取当前选中的缩略图索引
    var activeThumb = container.querySelector('.mt-custom-product-gallery-thumbs .active');
    var currentIndex = 0;
    if (activeThumb) {
        var thumbsArr = Array.from(thumbs);
        currentIndex = thumbsArr.indexOf(activeThumb.querySelector('img'));
        if (currentIndex < 0) currentIndex = 0;
    }

    // 切换到下一个缩略图
    if (currentIndex < thumbs.length - 1) {
        var nextIndex = currentIndex + 1;
        var nextThumb = thumbs[nextIndex];

        // 更新缩略图选中状态
        thumbs.forEach(t => t.parentElement.classList.remove('active'));
        nextThumb.parentElement.classList.add('active');

        // 切换主图
        changeMainImageWithSlide(slider, nextIndex);

        // 滚动到选中的缩略图（changeMainImageWithSlide 已经处理了，这里可以省略）
        // scrollToThumbnail(nextThumb.parentElement, thumbsWrapper);

        // 更新按钮状态（changeMainImageWithSlide 已经处理了，这里可以省略）
        // updateThumbNav();
    }
});

// 当缩略图选中状态改变时更新按钮状态
thumbs.forEach(function (thumb, index) {
    thumb.addEventListener('click', function () {
        // 延迟更新按钮状态，确保active类已更新
        setTimeout(updateThumbNav, 10);
    });
});

// 初始化按钮状态
updateThumbNav();

// 弹窗管理功能
function openOptionModal(optionIndex) {
    var modal = document.getElementById('mt-option-modal-' + optionIndex);
    if (modal) {
        syncModalOptionsStock(optionIndex);
        // 关闭其他已打开的弹窗
        document.querySelectorAll('.mt-option-modal.active').forEach(function(m) {
            m.classList.remove('active');
        });
        
        // 使用 requestAnimationFrame 确保浏览器已经渲染，然后再添加 active 类来触发 transform
        // 双重 requestAnimationFrame 确保浏览器已经完成布局和绘制
        requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                modal.classList.add('active');
            });
        });
        
        document.body.style.overflow = 'hidden';
    }
}

function closeOptionModal(optionIndex) {
    var modal = document.getElementById('mt-option-modal-' + optionIndex);
    if (modal) {
        modal.classList.remove('active');
        document.body.style.overflow = '';
    }
}

// 关闭所有弹窗
function closeAllOptionModals() {
    document.querySelectorAll('.mt-option-modal.active').forEach(function(modal) {
        var optionIndex = modal.dataset.optionIndex;
        closeOptionModal(optionIndex);
    });
}

function syncOptionModalFromValue(optionIndex, value) {
    if (value == null || value === '') return;
    var modal = document.getElementById('mt-option-modal-' + optionIndex);
    if (!modal) return;
    var radioInput = findModalRadio(modal, value);
    if (!radioInput || radioInput.disabled) {
        radioInput = modal.querySelector('input[type="radio"]:not(:disabled)');
    }
    if (!radioInput) return;
    radioInput.checked = true;
    var modalOptions = modal.querySelectorAll('.mt-option-modal-option');
    modalOptions.forEach(function (opt) {
        opt.classList.remove('selected');
    });
    var optionEl = radioInput.closest('.mt-option-modal-option');
    if (optionEl) optionEl.classList.add('selected');
}

function syncModalOptionsStock(optionIndex) {
    var modal = document.getElementById('mt-option-modal-' + optionIndex);
    var group = optionGroups[optionIndex];
    if (!modal || !group) return;

    group.querySelectorAll('.mt-custom-product-option-value').forEach(function (valueEl) {
        var radio = findModalRadio(modal, valueEl.dataset.value);
        if (!radio) return;
        var label = radio.closest('.mt-option-modal-option');
        var labelText = label ? label.querySelector('.mt-option-radio-label') : null;
        var isOos = valueEl.classList.contains('out-of-stock') || valueEl.dataset.disabled === 'true';

        if (labelText && !labelText.dataset.originalText) {
            labelText.dataset.originalText = labelText.textContent;
        }

        if (isOos) {
            radio.disabled = true;
            if (label) {
                label.classList.add('out-of-stock');
                label.setAttribute('aria-disabled', 'true');
            }
            if (labelText) {
                labelText.textContent = labelText.dataset.originalText + ' (' + soldOutText + ')';
            }
            if (radio.checked) {
                radio.checked = false;
                if (label) label.classList.remove('selected');
            }
        } else {
            radio.disabled = false;
            radio.removeAttribute('disabled');
            if (label) {
                label.classList.remove('out-of-stock');
                label.removeAttribute('aria-disabled');
            }
            if (labelText && labelText.dataset.originalText) {
                labelText.textContent = labelText.dataset.originalText;
            }
        }
    });

    var checkedAvailable = modal.querySelector('input[type="radio"]:checked:not(:disabled)');
    if (!checkedAvailable) {
        var firstAvailable = modal.querySelector('input[type="radio"]:not(:disabled)');
        if (firstAvailable) {
            firstAvailable.checked = true;
            var opt = firstAvailable.closest('.mt-option-modal-option');
            modal.querySelectorAll('.mt-option-modal-option').forEach(function (o) {
                o.classList.remove('selected');
            });
            if (opt) opt.classList.add('selected');
            var normalizedFirst = normalizeOptionValue(firstAvailable.value);
            group.querySelectorAll('.mt-custom-product-option-value').forEach(function (v) {
                v.classList.remove('selected');
                if (normalizeOptionValue(v.dataset.value) === normalizedFirst) {
                    v.classList.add('selected');
                }
            });
            var desc = group.querySelector('.mt-option-desc');
            if (desc) desc.textContent = firstAvailable.value;
        }
    }
}

function updateAddToCartState(matched) {
    var isAvailable = isVariantPurchasable(matched);
    var submitBtn = container.querySelector('.mt-custom-product-atc-btn') || atcBtn;
    var submitBtnText = submitBtn ? (submitBtn.querySelector('.mt-atc-button-text') || atcBtnText) : atcBtnText;

    if (variantIdInput) {
        if (matched) {
            variantIdInput.value = matched.id;
        }
        if (isAvailable) {
            variantIdInput.disabled = false;
            variantIdInput.removeAttribute('disabled');
        } else {
            variantIdInput.disabled = true;
        }
    }

    if (!submitBtn) return;

    if (isAvailable) {
        submitBtn.disabled = false;
        submitBtn.removeAttribute('disabled');
        submitBtn.removeAttribute('aria-disabled');
        if (submitBtnText && defaultAtcText) {
            submitBtnText.textContent = defaultAtcText;
        }
    } else {
        submitBtn.disabled = true;
        submitBtn.setAttribute('disabled', 'disabled');
        submitBtn.setAttribute('aria-disabled', 'true');
        if (submitBtnText) {
            submitBtnText.textContent = soldOutText;
        }
    }
}

// 内联选项按钮点击
optionGroups.forEach(function (group, optionIndex) {
    var optionValues = group.querySelectorAll('.mt-custom-product-option-value');
    optionValues.forEach(function (valueEl) {
        function selectOptionValue() {
            if (valueEl.classList.contains('out-of-stock') || valueEl.dataset.disabled === 'true') {
                return;
            }

            optionValues.forEach(function (v) {
                v.classList.remove('selected');
            });
            valueEl.classList.add('selected');
            syncGalleryWithVariant = true;
            updateOptionStock();
            updateStockDisplay();
        }

        valueEl.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            selectOptionValue();
        });

        valueEl.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                selectOptionValue();
            }
        });
    });
});

// 添加数量控制按钮的事件监听器（需要检查元素是否存在）
if (minusBtn && plusBtn && qtyInput) {
    minusBtn.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) qtyInput.value = val - 1;
        updateATCPrice();
    });
    plusBtn.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
        updateATCPrice();
    });
    qtyInput.addEventListener('input', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        if (val < 1) qtyInput.value = 1;
        updateStockDisplay();
        updateATCPrice();
    });
    qtyInput.addEventListener('change', updateATCPrice);
}

function updateATCPrice() {
    // var selectedOptions = [];
    // optionGroups.forEach(function (group) {
    //     var selected = group.querySelector('.selected');
    //     if (selected) selectedOptions.push(selected.dataset.value);
    // });
    // var matched = productData.variants.find(function (variant) {
    //     return variant.options.map(function (o) { return (o || '').trim(); }).join('|||') === selectedOptions.map(function (o) { return (o || '').trim(); }).join('|||');
    // });
    // var qty = (qtyInput && qtyInput.value) ? parseInt(qtyInput.value, 10) || 1 : 1;
    // if (matched && atcBtn) {
    //     atcBtn.textContent = matched.available ? `ADD TO CART – ${formatPrice(matched.price * qty)}` : 'Sold Out';
    // }
}

function updateOptionStock() {
    optionGroups.forEach(function (group, optionIndex) {
        var values = group.querySelectorAll('.mt-custom-product-option-value');
        values.forEach(function (valueEl) {
            valueEl.classList.remove('out-of-stock');
            valueEl.removeAttribute('data-disabled');
            var selectedOptions = [];
            optionGroups.forEach(function (g, idx) {
                if (idx === optionIndex) {
                    selectedOptions.push(normalizeOptionValue(valueEl.dataset.value));
                } else {
                    var selected = g.querySelector('.mt-custom-product-option-value.selected');
                    selectedOptions.push(selected ? normalizeOptionValue(selected.dataset.value) : '');
                }
            });
            var matched = productData.variants.find(function (variant) {
                return (
                    buildVariantOptionsKey(variant.options) === buildVariantOptionsKey(selectedOptions) &&
                    isVariantPurchasable(variant)
                );
            });
            if (!matched) {
                valueEl.classList.add('out-of-stock');
                valueEl.setAttribute('data-disabled', 'true');
            }
        });

        var selected = group.querySelector('.mt-custom-product-option-value.selected');
        if (selected && (selected.classList.contains('out-of-stock') || selected.dataset.disabled === 'true')) {
            selected.classList.remove('selected');
            var firstAvailable = group.querySelector('.mt-custom-product-option-value:not(.out-of-stock):not([data-disabled="true"])');
            if (firstAvailable) {
                firstAvailable.classList.add('selected');
                var desc = group.querySelector('.mt-option-desc');
                if (desc) desc.textContent = firstAvailable.dataset.value;
                syncOptionModalFromValue(optionIndex, firstAvailable.dataset.value);
            }
        }

        syncModalOptionsStock(optionIndex);
    });
    updateVariant();
    updateStockDisplay();
}

function updateStockDisplay() {
    var matched = findVariantByOptions(getSelectedOptions());
    if (stockEl) {
        if (matched && variantInventoryMap[matched.id] != null) {
            stockEl.textContent = variantInventoryMap[matched.id] + ' in stock';
        } else {
            stockEl.textContent = '0 in stock';
        }
    }
}

function updateVariantSelectionFromImage(variant) {
    syncGalleryWithVariant = true;
    // 根据变体的选项更新选择状态
    variant.options.forEach(function (optionValue, optionIndex) {
        var optionGroup = optionGroups[optionIndex];
        if (optionGroup) {
            var optionValues = optionGroup.querySelectorAll('.mt-custom-product-option-value');
            optionValues.forEach(function (valueEl) {
                if (normalizeOptionValue(valueEl.dataset.value) === normalizeOptionValue(optionValue)) {
                    // 移除当前选中状态
                    optionValues.forEach(v => v.classList.remove('selected'));
                    // 设置新的选中状态
                    valueEl.classList.add('selected');
                    // 更新描述
                    var desc = optionGroup.querySelector('.mt-option-desc');
                    if (desc) desc.textContent = optionValue;
                    
                    syncOptionModalFromValue(optionIndex, optionValue);
                }
            });
        }
    });

    // 更新变体信息
    updateVariant();
    updateOptionStock();
    updateStockDisplay();
}

// scrollToThumbnail 函数已移到全局作用域（在 hoverServiceItem 函数之后）

function updateThumbnailSelection(imageSrc) {
    // 移除所有缩略图的选中状态
    thumbs.forEach(function (thumb) {
        thumb.parentElement.classList.remove('active');
    });

    // 从目标图片URL中提取文件名（移除尺寸后缀）
    var targetFileName = imageSrc.split('/').pop().split('?')[0];
    targetFileName = targetFileName.replace(/[_-]\d+x\./, '.');

    // 找到对应的缩略图并选中
    var foundMatch = false;
    var matchCount = 0;
    var matchedThumb = null;

    thumbs.forEach(function (thumb, index) {
        var thumbFileName = thumb.src.split('/').pop().split('?')[0];
        // 移除缩略图的尺寸后缀
        thumbFileName = thumbFileName.replace(/[-_]\d+x\.jpg$/, '.jpg').replace(/[-_]\d+\.jpg$/, '.jpg');

        if (thumbFileName === targetFileName) {
            thumb.parentElement.classList.add('active');
            foundMatch = true;
            matchCount++;
            if (!matchedThumb) {
                matchedThumb = thumb.parentElement;
            }
        }
    });

    if (matchCount > 1) {
        // 如果有多个匹配，只保留第一个
        var activeThumbs = document.querySelectorAll('.mt-custom-product-gallery-thumbs .active');
        for (var i = 1; i < activeThumbs.length; i++) {
            activeThumbs[i].classList.remove('active');
        }
    }

    // 滚动到选中的缩略图
    var activeThumb = document.querySelector('.mt-custom-product-gallery-thumbs .active');
    if (activeThumb) {
        var thumbsWrapper = activeThumb.closest('.mt-custom-product-container')?.querySelector('.mt-custom-product-gallery-thumbs') || document.querySelector('.mt-custom-product-gallery-thumbs');
        scrollToThumbnail(activeThumb, thumbsWrapper);
    }

    return foundMatch;
}

function updateVariant() {
    syncHiddenOptionsFromModals();
    var matched = findVariantByOptions(getSelectedOptions());
    if (matched) {
        if (syncGalleryWithVariant) {
        // 强制更新缩略图选中状态
        function forceUpdateThumbnail() {
            var variantId = matched.id;
            var found = false;

            // 方法1: 通过变体ID直接匹配
            thumbs.forEach(function (thumb) {
                var tid = getDataAttr(thumb, ['variantId', 'data-variant-id', 'data_variant_id']);
                if (tid == variantId) {
                    thumbs.forEach(t => t.parentElement.classList.remove('active'));
                    thumb.parentElement.classList.add('active');
                    scrollToThumbnail(thumb.parentElement, thumbsWrapper);
                    found = true;
                }
            });

            // 方法2: 如果没有找到，尝试通过图片ID匹配
            var imageId = matched.image_id || (matched.featured_image && matched.featured_image.id);
            if (!found && imageId) {
                thumbs.forEach(function (thumb) {
                    var iid = getDataAttr(thumb, ['imageId', 'data-image-id', 'data_image_id']);
                    if (iid == imageId) {
                        thumbs.forEach(t => t.parentElement.classList.remove('active'));
                        thumb.parentElement.classList.add('active');
                        scrollToThumbnail(thumb.parentElement, thumbsWrapper);
                        found = true;
                    }
                });
            }

            return found;
        }

        function getDomThumbIndexByImageId(id) {
            if (!id) return -1;
            if (!thumbs || !thumbs.length) return -1;
            var thumbsArr = Array.from(thumbs);
            return thumbsArr.findIndex(function (t) {
                var iid = getDataAttr(t, ['imageId', 'data-image-id', 'data_image_id']);
                return iid == id;
            });
        }

        // 切换主图：优先使用“页面缩略图索引”（最贴近真实渲染顺序）
        var targetImageId = matched.image_id || (matched.featured_image && matched.featured_image.id);
        var domIndex = getDomThumbIndexByImageId(targetImageId);
        if (domIndex !== -1) {
            changeMainImageWithSlide(slider, domIndex);
        } else if (matched.featured_image && matched.featured_image.src) {
            // 兜底：src 匹配（可能会受文件名相似影响）
            var newImageSrc = matched.featured_image.src;
            if (newImageSrc.startsWith('//')) newImageSrc = window.location.protocol + newImageSrc;
            changeMainImageBySrc(slider, newImageSrc);
        } else {
            // 最后兜底：按 data-variant-id 找到缩略图
            var matchingThumb = null;
            thumbs.forEach(function (thumb) {
                var tid2 = getDataAttr(thumb, ['variantId', 'data-variant-id', 'data_variant_id']);
                if (tid2 == matched.id) matchingThumb = thumb;
            });
            if (matchingThumb) {
                var thumbSrc = matchingThumb.src.replace(/[_-]\d+x\./, '.');
                changeMainImageBySrc(slider, thumbSrc);
            }
        }

        // 强制更新缩略图选中状态
        forceUpdateThumbnail();
        }

        var formattedPrice = formatPrice(matched.price);
        priceEl.textContent = formattedPrice;

        // 重新计算折扣信息
        if (matched.compare_at_price && matched.compare_at_price > matched.price) {
            // 显示原价
            if (oldPriceEl) {
                oldPriceEl.textContent = formatPrice(matched.compare_at_price);
                oldPriceEl.style.display = 'inline';
            }

            // 计算并显示节省金额
            var discountAmount = matched.compare_at_price - matched.price;
            var discountPercentage = Math.round((discountAmount / matched.compare_at_price) * 100);

            if (saveEl) {
                saveEl.textContent = `Save ${formatPrice(discountAmount)} (${discountPercentage}%)`;
                saveEl.style.display = 'inline';
            }
        } else {
            // 没有折扣时隐藏相关元素
            if (oldPriceEl) {
                oldPriceEl.textContent = '';
                oldPriceEl.style.display = 'none';
            }
            if (saveEl) {
                saveEl.textContent = '';
                saveEl.style.display = 'none';
            }
        }
        if (stockEl) {
            if (variantInventoryMap[matched.id] != null) {
                stockEl.textContent = variantInventoryMap[matched.id] + ' in stock';
            } else {
                stockEl.textContent = '0 in stock';
            }
        }
        updateInventoryStatus(matched);
        updateAddToCartState(matched);
        updateATCPrice();
        // 切换变体时同步更新 URL 上的 variantId
        if (urlSyncEnabled) {
            updateUrlVariant(matched.id);
        }
    } else {
        if (stockEl) stockEl.textContent = '0 in stock';
        updateInventoryStatus(null);
        updateAddToCartState(null);
    }
}

if (expressPic) {
    // 移除所有现有的事件监听器（如果有的话）
    var newExpressPic = expressPic.cloneNode(true);
    expressPic.parentNode.replaceChild(newExpressPic, expressPic);
    expressPic = newExpressPic;

    // 添加点击事件监听器
    expressPic.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        // 找到当前活跃的主图索引
        var activeMainImage = slider.querySelector('.mt-custom-product-gallery-main-img.active');
        var currentIndex = 0;
        if (activeMainImage) {
            // 获取当前活跃主图的索引
            var mainImages = slider.querySelectorAll('.mt-custom-product-gallery-main-img');
            var mainImagesArr = Array.from(mainImages);
            currentIndex = mainImagesArr.indexOf(activeMainImage);
            if (currentIndex < 0) currentIndex = 0;
        }

        try {
            console.debug('[mt-main-click-expressPic]', {
                activeMainExists: !!activeMainImage,
                activeMainDatasetIndex: activeMainImage && activeMainImage.dataset ? activeMainImage.dataset.imageIndex : undefined,
                currentIndexComputed: currentIndex,
                modalSlidesCount: modalSlides ? modalSlides.length : undefined
            });
        } catch (err) {}


        // 比较当前主图与productImages数组
        if (activeMainImage && Array.isArray(productImages) && productImages[currentIndex]) {
            var currentMainSrc = activeMainImage.src;
            var modalImageSrc = productImages[currentIndex].src;

            // 安全地比较图片URL
            if (currentMainSrc && modalImageSrc) {
                var currentFileName = currentMainSrc.split('/').pop();
                var modalFileName = modalImageSrc.split('/').pop();
            } 
        }

        // 显示模态框并设置当前图片
        // 由于主图顺序与 modal slide 顺序可能不一致，这里按 src 做匹配定位
        if (modal) {
            modal.style.display = 'flex';
            document.body.style.overflow = 'hidden';
        }
        // modal 先显示，避免隐藏状态下的 scroll-snap 计算不准确
        showModalImage(currentIndex, true);
    });


    // 主图点击也放大当前缩略图选中的图片
    if (slider) {
        slider.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var activeMainImage = slider.querySelector('.mt-custom-product-gallery-main-img.active');
            var currentIndex = 0;
            if (activeMainImage) {
                var mainImages = slider.querySelectorAll('.mt-custom-product-gallery-main-img');
                var mainImagesArr = Array.from(mainImages);
                currentIndex = mainImagesArr.indexOf(activeMainImage);
                if (currentIndex < 0) currentIndex = 0;
            }

            try {
                console.log('[mt-main-click-slider]', {
                    activeMainExists: !!activeMainImage,
                    activeMainDatasetIndex: activeMainImage && activeMainImage.dataset ? activeMainImage.dataset.imageIndex : undefined,
                    currentIndexComputed: currentIndex,
                    modalSlidesCount: modalSlides ? modalSlides.length : undefined
                });
            } catch (err) {}
            // 由于主图顺序与 modal slide 顺序可能不一致，这里按 src 做匹配定位
            if (modal) {
                modal.style.display = 'flex';
                document.body.style.overflow = 'hidden';
            }
            // modal 先显示，避免隐藏状态下的 scroll-snap 计算不准确
            showModalImage(currentIndex, true);
        });
    }

    // 模态框导航功能
    var currentModalImageIndex = 0;
    var productImages = window.mtCustomProductData?.productImages || [];

    // Modal 放大/拖拽状态
    var isModalZoomed = false;
    var isModalPanning = false;
    var modalPanMoved = false; // 用于区分“拖拽”还是“点击”
    var modalSwipeMoved = false; // 用于区分“轮播拖拽”还是“点击”
    var MODAL_DEBUG = false; // 调试日志开关
    var modalZoomScale = 2; // 放大倍数（可按需求微调）
    var modalPanX = 0;
    var modalPanY = 0;
    var modalZoomImageEl = null; // 当前放大的那张 img
    var modalContentEl = container.querySelector('.mt-custom-product-image-modal-content');

    function applyModalZoomTransform(imgEl, panX, panY, zoomScale) {
        if (!imgEl) return;
        imgEl.style.transform = 'scale(' + zoomScale + ') translate3d(' + panX + 'px, ' + panY + 'px, 0)';
    }

    function resetModalZoom() {
        isModalZoomed = false;
        isModalPanning = false;
        modalPanMoved = false;
        modalSwipeMoved = false;
        modalPanX = 0;
        modalPanY = 0;
        modalZoomImageEl = null;

        if (MODAL_DEBUG) {
            console.log('[mt-modal-zoom] resetModalZoom()', {
                currentModalImageIndex: currentModalImageIndex,
                modalSlidesCount: modalSlides ? modalSlides.length : 0
            });
        }

        if (modalContentEl) modalContentEl.classList.remove('mt-modal-zoom-active');
        if (modalSlider) modalSlider.classList.remove('is-modal-zoomed', 'is-modal-panning');

        // 复位所有 modal 图片，避免切图后残留 transform
        if (Array.isArray(modalSlides) && modalSlides.length) {
            modalSlides.forEach(function (slide) {
                if (!slide) return;
                var imgEl = slide.querySelector ? slide.querySelector('.mt-modal-image') : null;
                if (!imgEl) return;
                imgEl.style.transform = 'scale(1) translate3d(0px, 0px, 0)';
            });
        }
    }

    function setModalZoom(imgEl) {
        if (!imgEl) return;
        isModalZoomed = true;
        isModalPanning = false;
        modalPanMoved = false;
        modalPanX = 0;
        modalPanY = 0;
        modalZoomImageEl = imgEl;

        if (MODAL_DEBUG) {
            var idx = imgEl && imgEl.dataset ? parseInt(imgEl.dataset.imageIndex, 10) : NaN;
            console.log('[mt-modal-zoom] setModalZoom()', {
                zoomScale: modalZoomScale,
                clickedIdx: idx,
                currentModalImageIndex: currentModalImageIndex
            });
        }

        if (modalContentEl) modalContentEl.classList.add('mt-modal-zoom-active');
        if (modalSlider) modalSlider.classList.add('is-modal-zoomed');

        applyModalZoomTransform(modalZoomImageEl, modalPanX, modalPanY, modalZoomScale);
    }

    function updateModalNavigation() {
        if (modalNavLeft && modalNavRight) {
            var total = modalSlides.length || (Array.isArray(productImages) ? productImages.length : 0);
            modalNavLeft.disabled = currentModalImageIndex === 0;
            modalNavRight.disabled = total ? currentModalImageIndex >= total - 1 : true;
        }
    }

    function imageKeyFromUrl(src) {
        if (!src) return '';
        var cleaned = String(src).split('?')[0];
        // normalize protocol-relative urls
        cleaned = cleaned.replace(/^\/\//, window.location.protocol + '//');
        // normalize Shopify size suffix patterns
        cleaned = cleaned.replace(/[_-]\d+x\./g, '.').replace(/[_-]\d+\./g, '.');
        var file = cleaned.split('/').pop() || cleaned;
        // remove extension to make jpg/webp/p.png all match
        return file.replace(/\.[a-z0-9]+$/i, '') || file;
    }

    function showModalImage(index, fromMain) {
        if (!modalSlider) return;
        if (isModalZoomed) resetModalZoom(); // 切到其它图片时回到未放大态
        if (index < 0) index = 0;

        // 首次打开时，从主图映射到 modal slide，避免索引错位
        if (fromMain === true && slider && modalSlides && modalSlides.length) {
            var mainImages = slider.querySelectorAll('.mt-custom-product-gallery-main-img');
            var mainImg = mainImages && mainImages[index];

            // 优先使用 data-image-index 精确映射（比 src 归一化更可靠）
            var desiredIndex = index;
            if (mainImg && mainImg.dataset && mainImg.dataset.imageIndex !== undefined) {
                var parsed = parseInt(mainImg.dataset.imageIndex, 10);
                if (!isNaN(parsed)) desiredIndex = parsed;
            }

            var matchedIndex = modalSlides.findIndex(function (slide) {
                if (!slide || !slide.dataset || slide.dataset.imageIndex === undefined) return false;
                var slideIdx = parseInt(slide.dataset.imageIndex, 10);
                return !isNaN(slideIdx) && slideIdx === desiredIndex;
            });

            // fallback：仍然找不到时，才用 src 做兼容匹配
            if (matchedIndex !== -1) {
                index = matchedIndex;
            } else {
                var mainKey = imageKeyFromUrl(mainImg && mainImg.src);
                if (mainKey) {
                    var matchedBySrc = modalSlides.findIndex(function (slide) {
                        var imgEl = slide && slide.querySelector ? slide.querySelector('.mt-modal-image') : null;
                        return imageKeyFromUrl(imgEl && imgEl.src) === mainKey;
                    });
                    if (matchedBySrc !== -1) index = matchedBySrc;
                }
            }

            try {
                var slideAfter = modalSlides[index];
                console.log('[mt-modal-open]', {
                    fromMain: fromMain,
                    indexPassed: index,
                    desiredIndex: desiredIndex,
                    mainImgDatasetIndex: mainImg && mainImg.dataset ? mainImg.dataset.imageIndex : undefined,
                    mainImgSrc: mainImg && mainImg.src ? mainImg.src : undefined,
                    matchedIndex: matchedIndex,
                    slideDatasetIndex: slideAfter && slideAfter.dataset ? slideAfter.dataset.imageIndex : undefined,
                    slideSrc: slideAfter && slideAfter.src ? slideAfter.src : undefined,
                    modalSlidesCount: modalSlides.length
                });
            } catch (err) {
                // avoid breaking UX
            }
        }

        if (modalSlides.length && index >= modalSlides.length) index = modalSlides.length - 1;
        currentModalImageIndex = index;

        var slide = modalSlides[index];
        if (slide) {
            // 滑动到对应 slide（PC/M 都可拖拽/滑动）
            // 从主图打开时使用 auto，避免“打开后又过渡滚动一次”的错觉；
            // 弹窗内切换时保持 smooth。
            var scrollBehavior = fromMain === true ? 'auto' : 'smooth';
            modalSlider.scrollTo({ left: slide.offsetLeft, behavior: scrollBehavior });
        }
        updateModalNavigation();
    }

    // 左侧导航按钮事件
    if (modalNavLeft) {
        modalNavLeft.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            // 放大态下先退出缩放，避免拖拽平移与切图逻辑冲突
            if (isModalZoomed) resetModalZoom();
            if (currentModalImageIndex > 0) {
                showModalImage(currentModalImageIndex - 1);
            }
        });
    }

    // 右侧导航按钮事件
    if (modalNavRight) {
        modalNavRight.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            // 放大态下先退出缩放，避免拖拽平移与切图逻辑冲突
            if (isModalZoomed) resetModalZoom();
            if (Array.isArray(productImages) && currentModalImageIndex < productImages.length - 1) {
                showModalImage(currentModalImageIndex + 1);
            }
        });
    }

    if (closeModalBtn) {
        closeModalBtn.addEventListener('click', function () {
            resetModalZoom();
            modal.style.display = 'none';
            document.body.style.overflow = '';
        });
    }
    if (closeModalBtn3) {
        closeModalBtn3.addEventListener('click', function () {
            resetModalZoom();
            modal.style.display = 'none';
            document.body.style.overflow = '';
        });
    }
    // 旧逻辑：点击单张图片关闭。现在改为滑动轮播，避免误触，不再绑定。

    // 添加点击弹窗背景关闭弹窗的功能
    if (modal) {
        modal.addEventListener('click', function (e) {
            // 如果点击的是弹窗背景（不是弹窗内容），则关闭弹窗
            if (e.target === modal) {
                resetModalZoom();
                modal.style.display = 'none';
                document.body.style.overflow = '';
            }
        });
    }

    // 添加ESC键关闭弹窗功能
    document.addEventListener('keydown', function (e) {
        if (modal && modal.style.display === 'flex') {
            if (e.key === 'Escape') {
                resetModalZoom();
                modal.style.display = 'none';
                document.body.style.overflow = '';
            } else if (!isModalZoomed && e.key === 'ArrowLeft' && currentModalImageIndex > 0) {
                showModalImage(currentModalImageIndex - 1);
            } else if (!isModalZoomed && e.key === 'ArrowRight' && Array.isArray(productImages) && currentModalImageIndex < productImages.length - 1) {
                showModalImage(currentModalImageIndex + 1);
            }
        }
    });

    // modal 内：点图片切换放大态（放大后再点一次回缩回原尺寸）
    if (modalSlider && modalSlides.length) {
        modalSlider.addEventListener('click', function (e) {
            // 当前 zoom/回缩逻辑在 pointerup 里处理；避免 click 造成重复触发
            return;
            // 如果刚刚是拖拽产生的 click，忽略这次点击
            if (modalPanMoved || modalSwipeMoved || isModalPanning) {
                if (MODAL_DEBUG) {
                    console.debug('[mt-modal-zoom][click-ignored]', {
                        modalPanMoved: modalPanMoved,
                        modalSwipeMoved: modalSwipeMoved,
                        isModalPanning: isModalPanning,
                        currentModalImageIndex: currentModalImageIndex,
                        isModalZoomed: isModalZoomed
                    });
                }
                modalPanMoved = false;
                modalSwipeMoved = false;
                return;
            }

            var clickedImg = e.target && e.target.closest ? e.target.closest('.mt-modal-image') : null;
            if (!clickedImg) {
                if (MODAL_DEBUG) {
                    console.debug('[mt-modal-zoom][click-no-img]', {
                        tag: e.target && e.target.tagName ? e.target.tagName : null,
                        className: e.target && e.target.className ? e.target.className : null,
                        currentModalImageIndex: currentModalImageIndex,
                        isModalZoomed: isModalZoomed
                    });
                }
                return;
            }

            var idx = parseInt(clickedImg.dataset ? clickedImg.dataset.imageIndex : NaN, 10);
            if (isNaN(idx)) {
                if (MODAL_DEBUG) {
                    console.debug('[mt-modal-zoom][click-img-no-index]', {
                        currentModalImageIndex: currentModalImageIndex,
                        isModalZoomed: isModalZoomed
                    });
                }
                return;
            }

            if (MODAL_DEBUG) {
                console.debug('[mt-modal-zoom][click]', {
                    clickedIdx: idx,
                    currentModalImageIndex: currentModalImageIndex,
                    isModalZoomed: isModalZoomed,
                    clickedIsCurrent: idx === currentModalImageIndex
                });
            }

            // 非当前显示的图片：先切到对应 slide
            if (idx !== currentModalImageIndex) {
                showModalImage(idx, false);
                return;
            }

            if (isModalZoomed) {
                if (MODAL_DEBUG) console.debug('[mt-modal-zoom] resetModalZoom');
                resetModalZoom();
            } else {
                if (MODAL_DEBUG) console.debug('[mt-modal-zoom] setModalZoom');
                setModalZoom(clickedImg);
            }
        });
    }

    // Modal slider: drag/swipe with threshold -> only +/- 1 slide each time (PC/M)
    if (modalSlider && modalSlides.length) {
        var modalIsDragging = false;
        var modalStartX = 0;
        var modalStartLeft = 0;
        var modalStartIndex = 0;
        var modalDragOffsetX = 0;
        var modalScrollTimer = null;

        var modalPanStartX = 0;
        var modalPanStartY = 0;
        var modalPanStartOffsetX = 0;
        var modalPanStartOffsetY = 0;
    var modalPointerDownImgEl = null; // 缓存 pointerdown 命中的图片（pointerup 时 target 可能变为 slider DIV）
    var modalPanFrameEl = null; // 放大态拖拽时用于计算边界的“图片外框”（slide 容器）

        // 通过每张 slide 的 offsetLeft 计算当前所在 index
        // 避免使用 clientWidth 导致滑动宽度与 slide 实际宽度不一致时错位
        function modalIndexFromScrollLeft(left) {
            if (!modalSlides || !modalSlides.length) return 0;
            var bestIdx = 0;
            var bestDist = Infinity;
            for (var i = 0; i < modalSlides.length; i++) {
                var slide = modalSlides[i];
                if (!slide) continue;
                var dist = Math.abs(slide.offsetLeft - left);
                if (dist < bestDist) {
                    bestDist = dist;
                    bestIdx = i;
                }
            }
            return bestIdx;
        }

        modalSlider.addEventListener('pointerdown', function (e) {
            if (e.pointerType === 'mouse' && e.button !== 0) return;

            // 关键调试：确认 pointerdown 是否落到了我们这里
            if (MODAL_DEBUG) {
                var t = e.target;
                console.log('[mt-modal-zoom][pointerdown]', {
                    pointerType: e.pointerType,
                    isModalZoomed: isModalZoomed,
                    targetTag: t && t.tagName ? t.tagName : null,
                    targetClass: t && t.className ? t.className : null
                });
            }

            // 缓存 pointerdown 命中的图片，避免 pointerup 时 e.target 变成容器 DIV
            modalPointerDownImgEl = e.target && e.target.closest ? e.target.closest('.mt-modal-image') : null;

            // 放大态：拖拽平移当前图片（不再轮播切图）
            if (isModalZoomed) {
                var activeSlide = modalSlides[currentModalImageIndex];
                var activeImg = activeSlide && activeSlide.querySelector ? activeSlide.querySelector('.mt-modal-image') : null;
                var clickedImg = e.target && e.target.closest ? e.target.closest('.mt-modal-image') : null;
                if (activeImg && clickedImg && clickedImg === activeImg) {
                    isModalPanning = true;
                    modalPanMoved = false;
                    modalPanFrameEl = activeSlide;
                    modalPanStartX = e.clientX;
                    modalPanStartY = e.clientY;
                    modalPanStartOffsetX = modalPanX;
                    modalPanStartOffsetY = modalPanY;

                    if (modalSlider) modalSlider.classList.add('is-modal-panning');

                    try { modalSlider.setPointerCapture(e.pointerId); } catch (_) {}
                    e.preventDefault();
                }
                return;
            }

            modalIsDragging = true;
            modalStartX = e.clientX;
            modalStartLeft = modalSlider.scrollLeft;
            modalStartIndex = modalIndexFromScrollLeft(modalStartLeft);
            modalDragOffsetX = 0;
            modalSwipeMoved = false;
            try { modalSlider.setPointerCapture(e.pointerId); } catch (_) {}
            // 防止产生惯性/选中文本
            e.preventDefault();
        }, { passive: false });

        modalSlider.addEventListener('pointermove', function (e) {
            // 放大态：图片拖拽平移
            if (isModalZoomed && isModalPanning && modalZoomImageEl) {
                var dx = e.clientX - modalPanStartX;
                var dy = e.clientY - modalPanStartY;

                if (Math.abs(dx) + Math.abs(dy) > 3) modalPanMoved = true;

                var frameW = modalPanFrameEl && modalPanFrameEl.clientWidth ? modalPanFrameEl.clientWidth : (modalSlider.clientWidth || 1);
                var frameH = modalPanFrameEl && modalPanFrameEl.clientHeight ? modalPanFrameEl.clientHeight : (modalSlider.clientHeight || 1);
                var scaledW = frameW * modalZoomScale;
                var scaledH = frameH * modalZoomScale;
                var maxX = Math.max(0, (scaledW - frameW) / 2);
                var maxY = Math.max(0, (scaledH - frameH) / 2);

                modalPanX = Math.max(-maxX, Math.min(maxX, modalPanStartOffsetX + dx));
                modalPanY = Math.max(-maxY, Math.min(maxY, modalPanStartOffsetY + dy));

                applyModalZoomTransform(modalZoomImageEl, modalPanX, modalPanY, modalZoomScale);
                e.preventDefault();
                return;
            }

            if (!modalIsDragging) return;
            modalDragOffsetX = e.clientX - modalStartX;
            if (Math.abs(modalDragOffsetX) > 3) modalSwipeMoved = true;
            modalSlider.scrollLeft = modalStartLeft - modalDragOffsetX;
            e.preventDefault();
        }, { passive: false });

        function modalEndDrag() {
            // 放大态拖拽结束
            if (isModalPanning) {
                isModalPanning = false;
                if (modalSlider) modalSlider.classList.remove('is-modal-panning');
                modalPanFrameEl = null;
                return;
            }

            if (!modalIsDragging) return;
            modalIsDragging = false;
            var w = modalSlider.clientWidth || 1;
            var threshold = w * 0.3;
            var nextIndex = modalStartIndex;
            if (Math.abs(modalDragOffsetX) > threshold) {
                // 向左拖（offsetX<0）= 下一张；向右拖（offsetX>0）= 上一张
                nextIndex = modalStartIndex + (modalDragOffsetX < 0 ? 1 : -1);
            }
            nextIndex = Math.max(0, Math.min(nextIndex, modalSlides.length - 1));
            currentModalImageIndex = nextIndex;
            var nextSlide = modalSlides[nextIndex];
            if (nextSlide) {
                modalSlider.scrollTo({ left: nextSlide.offsetLeft, behavior: 'smooth' });
            }
            updateModalNavigation();
            modalDragOffsetX = 0;
        }

        modalSlider.addEventListener('pointerup', function (e) {
            var wasPanning = isModalPanning;

            // 关键调试：确认 pointerup 是否落到了我们这里
            if (MODAL_DEBUG) {
                var t = e.target;
                console.log('[mt-modal-zoom][pointerup]', {
                    isModalZoomed: isModalZoomed,
                    isModalPanning: isModalPanning,
                    wasPanning: wasPanning,
                    targetTag: t && t.tagName ? t.tagName : null,
                    targetClass: t && t.className ? t.className : null
                });
            }
            modalEndDrag();

            // 只有“未拖拽/未滑动”的纯点击，才切换 zoom
            if (!modalSlides || !modalSlides.length) return;

            var clickedImg = modalPointerDownImgEl;
            modalPointerDownImgEl = null;
            if (!clickedImg) {
                // 点击在“图片外空白区域”（不属于 img）时：未拖拽则关闭弹窗
                if (!modalSwipeMoved && !modalPanMoved) {
                    resetModalZoom();
                    modal.style.display = 'none';
                    document.body.style.overflow = '';
                }
                return;
            }

            var idx = parseInt(clickedImg.dataset ? clickedImg.dataset.imageIndex : NaN, 10);
            if (isNaN(idx)) return;
            if (idx !== currentModalImageIndex) {
                // 当前放大态：点到别的图先回缩，再切换到该图（保持和你的“再点一次回缩”逻辑一致）
                if (isModalZoomed) resetModalZoom();
                showModalImage(idx, false);
                return;
            }

            // 轮播拖拽/放大拖拽都结束后：
            // - 如果发生了位移（确实在拖拽平移）则不切换 zoom
            // - 如果只是“点击”（没产生位移）则允许 reset 回原尺寸
            if (wasPanning && modalPanMoved) return;
            if (modalSwipeMoved || modalPanMoved) return;

            if (isModalZoomed) {
                if (MODAL_DEBUG) console.debug('[mt-modal-zoom][pointerup] reset');
                resetModalZoom();
            } else {
                if (MODAL_DEBUG) console.debug('[mt-modal-zoom][pointerup] zoom');
                setModalZoom(clickedImg);
            }
        }, { passive: true });
        modalSlider.addEventListener('pointercancel', function () { modalEndDrag(); }, { passive: true });
        modalSlider.addEventListener('lostpointercapture', function () { modalEndDrag(); }, { passive: true });

        // 非拖拽滚动（例如按钮/键盘触发）时，同步 index（不允许一次跳多张：最终以最近一张为准）
        modalSlider.addEventListener('scroll', function () {
            if (modalIsDragging || isModalZoomed) return;
            if (modalScrollTimer) clearTimeout(modalScrollTimer);
            modalScrollTimer = setTimeout(function () {
                var w = modalSlider.clientWidth || 1;
                var idx = modalIndexFromScrollLeft(modalSlider.scrollLeft);
                if (idx !== currentModalImageIndex) {
                    currentModalImageIndex = idx;
                    updateModalNavigation();
                }
                var activeSlide = modalSlides[idx];
                if (activeSlide) {
                    modalSlider.scrollTo({ left: activeSlide.offsetLeft, behavior: 'smooth' });
                }
            }, 120);
        }, { passive: true });
    }
} // 闭合 if (expressPic) 块

    // ✅ 根据 URL 中的 variantId（兼容原生 variant）预选指定变体
    var urlVariantId = getVariantIdFromUrl();
    if (urlVariantId) {
        var urlVariant = productData.variants.find(function (v) {
            return String(v.id) === String(urlVariantId);
        });
        if (urlVariant && Array.isArray(urlVariant.options)) {
            urlVariant.options.forEach(function (optionValue, optionIndex) {
                var group = optionGroups[optionIndex];
                if (!group) return;
                var normalized = normalizeOptionValue(optionValue);
                group.querySelectorAll('.mt-custom-product-option-value').forEach(function (v) {
                    v.classList.remove('selected');
                    if (normalizeOptionValue(v.dataset.value) === normalized) {
                        v.classList.add('selected');
                    }
                });
                var desc = group.querySelector('.mt-option-desc');
                if (desc) desc.textContent = optionValue;
                syncOptionModalFromValue(optionIndex, optionValue);
            });
        }
    }

    // ✅ 初始化默认选项（防止初次加载无库存）
    optionGroups.forEach(function (group, optionIndex) {
        var selected = group.querySelector('.selected');
        if (!selected) {
            var first = group.querySelector('.mt-custom-product-option-value:not(.out-of-stock):not([data-disabled="true"])');
            if (first) {
                first.classList.add('selected');
                var desc = group.querySelector('.mt-option-desc');
                if (desc) desc.textContent = first.dataset.value;
                
                syncOptionModalFromValue(optionIndex, first.dataset.value);
            }
        } else {
            syncOptionModalFromValue(optionIndex, selected.dataset.value);
        }
    });

    updateVariant();
    updateOptionStock();
    updateStockDisplay();

    // 进入详情页/刷新时，始终定位到产品主图（非默认 SKU 图）
    function getProductFeaturedImageIndex() {
        var featuredId = productData.featured_image && productData.featured_image.id;
        if (!featuredId && productData.images && productData.images.length) {
            featuredId = productData.images[0].id;
        }
        if (!featuredId || !thumbs.length) return 0;

        var thumbsArr = Array.from(thumbs);
        var idx = thumbsArr.findIndex(function (t) {
            var iid = getDataAttr(t, ['imageId', 'data-image-id', 'data_image_id']);
            return String(iid) === String(featuredId);
        });
        return idx !== -1 ? idx : 0;
    }

    function initializeMainGalleryPosition() {
        changeMainImageWithSlide(slider, getProductFeaturedImageIndex(), false);
    }

    initializeMainGalleryPosition();
    requestAnimationFrame(function () {
        requestAnimationFrame(initializeMainGalleryPosition);
    });
    window.addEventListener('load', initializeMainGalleryPosition);

    // 初始化完成，之后用户切换变体才会写入 URL
    urlSyncEnabled = true;

    // tying_products 下拉框初始化
    initTyingProducts(container);

    // Accordion Functions
    setTimeout(function () {
        var accordionItems = document.querySelectorAll('.mt-accordion-item');

        accordionItems.forEach(function (item, index) {
            var titleBox = item.querySelector('.mt-accordion-title-box');
            var content = item.querySelector('.mt-accordion-content');
            var icon = item.querySelector('.mt-accordion-icon');

            if (titleBox && content && icon) {
                // 初始展开逻辑：如果有open类则展开
                if (content.classList.contains('open')) {
                    icon.classList.add('rotated');
                }
                titleBox.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    var isOpen = content.classList.contains('open');

                    // 关闭所有其他手风琴项目
                    document.querySelectorAll('.mt-accordion-content').forEach(function (c) {
                        if (c !== content) {
                            c.classList.remove('open');
                        }
                    });
                    document.querySelectorAll('.mt-accordion-icon').forEach(function (i) {
                        if (i !== icon) {
                            i.classList.remove('rotated');
                        }
                    });

                    // 切换当前手风琴项目
                    if (isOpen) {
                        content.classList.remove('open');
                        icon.classList.remove('rotated');
                    } else {
                        content.classList.add('open');
                        icon.classList.add('rotated');
                    }
                });
            }
        });
    }, 100);
    }); // DOMContentLoaded 闭合

// tying_products 下拉框初始化
function initTyingProducts(container) {
    if (!container) return;

    var tyingWrapper = container.querySelector('.tying-products__wrapper--dropdown');
    if (!tyingWrapper) return;

    var header = tyingWrapper.querySelector('.tying-products__header');
    var items = tyingWrapper.querySelectorAll('.tying-product');
    var checks = tyingWrapper.querySelectorAll('.tying-product__check');
    var summaryEl = tyingWrapper.querySelector('.tying-products__selected-text');

    function getTitleFromCheckbox(checkbox) {
        if (!checkbox) return '';
        var item = checkbox.closest('.tying-product');
        if (!item) return '';
        var nameEl = item.querySelector('.tying-product__name');
        return nameEl ? nameEl.textContent.replace(/\s+/g, ' ').trim() : '';
    }

    function syncSelectedState() {
        items.forEach(function (item) {
            var checkbox = item.querySelector('.tying-product__check');
            item.classList.toggle('selected', !!(checkbox && checkbox.checked));
        });
    }

    function updateSummary() {
        if (!summaryEl) return;
        var checkedTitle = '';

        checks.forEach(function (checkbox) {
            if (checkbox.checked) {
                checkedTitle = getTitleFromCheckbox(checkbox);
            }
        });

        summaryEl.textContent = checkedTitle;
    }

    function selectItem(item) {
        if (!item) return;
        var checkbox = item.querySelector('.tying-product__check');
        if (!checkbox) return;

        checks.forEach(function (cb) {
            cb.checked = false;
        });
        checkbox.checked = true;
        syncSelectedState();
        updateSummary();
    }

    function toggleDropdown(forceOpen) {
        var isOpen = tyingWrapper.classList.contains('selected');
        var nextOpen = typeof forceOpen === 'boolean' ? forceOpen : !isOpen;
        tyingWrapper.classList.toggle('selected', nextOpen);
        if (header) {
            header.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
        }
    }

    if (header) {
        header.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            toggleDropdown();
        });

        header.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                toggleDropdown();
            }
        });
    }

    items.forEach(function (item) {
        item.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            selectItem(item);
        });
    });

    document.addEventListener('click', function (e) {
        if (!tyingWrapper.contains(e.target)) {
            toggleDropdown(false);
        }
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && tyingWrapper.classList.contains('selected')) {
            toggleDropdown(false);
        }
    });

    syncSelectedState();
    updateSummary();
}

function changeMainImageWithSlide(slider, targetIndex, smooth) {
    if (smooth === undefined) smooth = true;
    const images = slider.querySelectorAll('.mt-custom-product-gallery-main-img');


    // 确保targetIndex在有效范围内
    if (targetIndex < 0 || targetIndex >= images.length) {
        console.warn('[changeMainImageWithSlide] targetIndex 超出范围，重置为 0');
        targetIndex = 0;
    }

    // 移除所有图片的active类
    images.forEach(img => img.classList.remove('active'));

    // 添加目标图片的active类
    if (images[targetIndex]) {
        images[targetIndex].classList.add('active');
    }

    // PC：继续使用 translateY；M：改为原生横向滚动（可手指滑动）
    if (window.innerWidth < 990) {
        if (images[targetIndex]) {
            var slideWidth = slider.clientWidth || images[targetIndex].offsetWidth || 1;
            var targetLeft = targetIndex * slideWidth;
            if (smooth) {
                slider.scrollTo({ left: targetLeft, behavior: 'smooth' });
            } else {
                slider.scrollLeft = targetLeft;
            }
        }
        // 避免与旧 transform 逻辑冲突
        slider.style.transform = 'translateX(0)';
    } else {
        // 计算滑动距离（纵向）
        const slideDistance = -targetIndex * 100;
        if (!smooth) {
            var prevTransition = slider.style.transition;
            slider.style.transition = 'none';
            slider.style.transform = `translateY(${slideDistance}%)`;
            void slider.offsetHeight;
            slider.style.transition = prevTransition;
        } else {
            slider.style.transform = `translateY(${slideDistance}%)`;
        }
    }

    // 同步更新缩略图的选中状态、滚动位置和导航按钮状态
    syncThumbnailWithMainImage(slider, targetIndex);
}

function getActiveMainImageIndex(slider) {
    if (!slider) return 0;
    var images = slider.querySelectorAll('.mt-custom-product-gallery-main-img');
    if (!images.length) return 0;

    var activeImg = slider.querySelector('.mt-custom-product-gallery-main-img.active');
    if (!activeImg) return 0;

    var idx = parseInt(activeImg.dataset.imageIndex, 10);
    if (!isNaN(idx)) return idx;

    var domIndex = Array.from(images).indexOf(activeImg);
    return domIndex >= 0 ? domIndex : 0;
}

function syncMainGalleryPosition(slider, smooth) {
    if (!slider) return;
    var targetIndex = getActiveMainImageIndex(slider);
    changeMainImageWithSlide(slider, targetIndex, smooth !== false);
}

// Mobile main slider: drag/swipe with threshold -> only +/- 1 slide each time
document.addEventListener('DOMContentLoaded', function () {
    try {
        var productId = window.mtCustomProductData?.productId;
        if (!productId) return;
        var container = document.getElementById('mt-custom-product-' + productId);
        if (!container) return;
        var slider = container.querySelector('.mt-custom-product-gallery-slider');
        if (!slider) return;

        var images = Array.from(slider.querySelectorAll('.mt-custom-product-gallery-main-img'));
        if (!images.length) return;

        var isDragging = false;
        var startX = 0;
        var startLeft = 0;
        var startIndex = 0;
        var dragOffsetX = 0;
        var scrollTimer = null;

        function indexFromLeft(left, w) {
            return Math.max(0, Math.min(Math.round(left / w), images.length - 1));
        }

        slider.addEventListener('pointerdown', function (e) {
            if (window.innerWidth >= 990) return;
            if (e.pointerType === 'mouse' && e.button !== 0) return;
            isDragging = true;
            startX = e.clientX;
            startLeft = slider.scrollLeft;
            var w = slider.clientWidth || 1;
            startIndex = indexFromLeft(startLeft, w);
            dragOffsetX = 0;
            try { slider.setPointerCapture(e.pointerId); } catch (_) {}
            e.preventDefault();
        }, { passive: false });

        slider.addEventListener('pointermove', function (e) {
            if (!isDragging) return;
            if (window.innerWidth >= 990) return;
            dragOffsetX = e.clientX - startX;
            slider.scrollLeft = startLeft - dragOffsetX;
            e.preventDefault();
        }, { passive: false });

        function endDrag() {
            if (!isDragging) return;
            isDragging = false;
            var w = slider.clientWidth || 1;
            var threshold = w * 0.3;
            var nextIndex = startIndex;
            if (Math.abs(dragOffsetX) > threshold) {
                nextIndex = startIndex + (dragOffsetX < 0 ? 1 : -1);
            }
            nextIndex = Math.max(0, Math.min(nextIndex, images.length - 1));
            images.forEach(img => img.classList.remove('active'));
            if (images[nextIndex]) images[nextIndex].classList.add('active');
            syncThumbnailWithMainImage(slider, nextIndex);
            slider.scrollTo({ left: nextIndex * w, behavior: 'smooth' });
            dragOffsetX = 0;
        }

        slider.addEventListener('pointerup', function () { endDrag(); }, { passive: true });
        slider.addEventListener('pointercancel', function () { endDrag(); }, { passive: true });
        slider.addEventListener('lostpointercapture', function () { endDrag(); }, { passive: true });

        // 非拖拽滚动（例如点击缩略图/按钮触发）时，最终也对齐到最近一张
        slider.addEventListener('scroll', function () {
            if (window.innerWidth >= 990) return; // 仅移动端
            if (isDragging) return;
            if (scrollTimer) clearTimeout(scrollTimer);
            scrollTimer = setTimeout(function () {
                var w = slider.clientWidth || 1;
                var idx = indexFromLeft(slider.scrollLeft, w);
                images.forEach(img => img.classList.remove('active'));
                if (images[idx]) images[idx].classList.add('active');
                syncThumbnailWithMainImage(slider, idx);
                slider.scrollTo({ left: idx * w, behavior: 'smooth' });
            }, 120);
        }, { passive: true });
    } catch (e) {
        // ignore
    }
});

// 辅助函数：根据主图索引同步更新缩略图选中状态、滚动位置和导航按钮
function syncThumbnailWithMainImage(slider, targetIndex) {
    
    // 从slider的容器中查找缩略图
    var container = slider.closest('.mt-custom-product-container');
    if (!container) {
        // 如果找不到容器，尝试通过slider的父元素查找
        container = slider.parentElement;
        while (container && !container.classList.contains('mt-custom-product-container')) {
            container = container.parentElement;
        }
    }
    
    if (!container) {
        console.warn('[syncThumbnailWithMainImage] 未找到容器元素');
        return;
    }
    
    var thumbs = container.querySelectorAll('.mt-custom-product-gallery-thumbs img');
    var thumbsWrapper = container.querySelector('.mt-custom-product-gallery-thumbs');
    var leftBtn = container.querySelector('.mt-custom-product-gallery-nav.left');
    var rightBtn = container.querySelector('.mt-custom-product-gallery-nav.right');
    
    
    if (thumbs && thumbs.length > 0) {
        // 确保targetIndex在有效范围内
        if (targetIndex < 0) targetIndex = 0;
        if (targetIndex >= thumbs.length) targetIndex = thumbs.length - 1;
        
        
        // 移除所有缩略图的active类
        thumbs.forEach(thumb => {
            if (thumb.parentElement) {
                thumb.parentElement.classList.remove('active');
            }
        });
        
        // 添加对应索引缩略图的active类
        if (thumbs[targetIndex] && thumbs[targetIndex].parentElement) {
            thumbs[targetIndex].parentElement.classList.add('active');
            
            // 滚动到选中的缩略图
            if (thumbsWrapper) {
                scrollToThumbnail(thumbs[targetIndex].parentElement, thumbsWrapper);
            }
        } 
        
        // 更新导航按钮状态
        if (leftBtn && rightBtn) {
            leftBtn.disabled = targetIndex <= 0;
            rightBtn.disabled = targetIndex >= thumbs.length - 1;
            
            
            // 更新按钮背景样式
            if (targetIndex <= 0) {
                leftBtn.style.background = "#FBFAF8";
                var leftSvg = leftBtn.querySelector('svg');
                if (leftSvg) {
                    leftSvg.style.color = '#E2DBD3';
                }
            } else {
                leftBtn.style.background = "#E2DBD3";
                var leftSvg = leftBtn.querySelector('svg');
                if (leftSvg) {
                    leftSvg.style.color = '#333';
                }
            }
            
            if (targetIndex >= thumbs.length - 1) {
                rightBtn.style.background = "#FBFAF8";
                var rightSvg = rightBtn.querySelector('svg');
                if (rightSvg) {
                    rightSvg.style.color = '#E2DBD3';
                }
            } else {
                rightBtn.style.background = "#E2DBD3";
                var rightSvg = rightBtn.querySelector('svg');
                if (rightSvg) {
                    rightSvg.style.color = '#333';
                }
            }
        }
    } else {
        console.warn('[syncThumbnailWithMainImage] 未找到缩略图元素');
    }
}

function changeMainImageBySrc(slider, newSrc) {
    
    const images = slider.querySelectorAll('.mt-custom-product-gallery-main-img');
    let targetIndex = -1;

    // 从newSrc中提取文件名（移除尺寸后缀和查询参数）
    var targetFileName = newSrc.split('/').pop().split('?')[0];
    targetFileName = targetFileName.replace(/[_-]\d+x\./, '.').replace(/[_-]\d+\./, '.');
    

    // 找到匹配的图片索引
    images.forEach((img, index) => {
        var imgFileName = img.src.split('/').pop().split('?')[0];
        imgFileName = imgFileName.replace(/[_-]\d+x\./, '.').replace(/[_-]\d+\./, '.');
        
        // 比较文件名或完整URL
        if (img.src === newSrc || img.src.includes(newSrc.split('/').pop()) || imgFileName === targetFileName) {
            targetIndex = index;
        }
    });

    if (targetIndex !== -1) {
        changeMainImageWithSlide(slider, targetIndex);
    } else {
        // 如果找不到匹配的图片，尝试根据当前激活的主图同步缩略图
        syncThumbnailFromActiveMainImage(slider);
    }
}

// 辅助函数：根据当前激活的主图自动同步缩略图选中状态、滚动位置和导航按钮
function syncThumbnailFromActiveMainImage(slider) {
    
    const images = slider.querySelectorAll('.mt-custom-product-gallery-main-img');
    let activeIndex = -1;
    
    // 找到当前激活的主图索引
    images.forEach((img, index) => {
        if (img.classList.contains('active')) {
            activeIndex = index;
        }
    });
    
    // 如果找到了激活的主图，同步缩略图
    if (activeIndex !== -1) {
        syncThumbnailWithMainImage(slider, activeIndex);
    } 
}

// 复制功能：点击 mt-copy 元素复制 data-copy 内容并显示提示
document.addEventListener('DOMContentLoaded', function() {
    // 使用事件委托处理动态添加的元素
    document.addEventListener('click', function(e) {
        const copyWrapper = e.target.closest('.mt-copy-wrapper');
        if (!copyWrapper) return;
        
        const copyText = copyWrapper.getAttribute('data-copy');
        if (!copyText) return;
        
        // 恢复所有其他 SVG 到原始状态
        const allCopyWrappers = document.querySelectorAll('.mt-copy-wrapper');
        allCopyWrappers.forEach(function(wrapper) {
            if (wrapper !== copyWrapper) {
                wrapper.classList.remove('copied');
            }
        });
        
        // 复制到剪贴板
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(copyText).then(function() {
                // 显示成功状态
                copyWrapper.classList.add('copied');
                
              
            })
        } else {
            // 降级方案：使用传统方法
            const textArea = document.createElement('textarea');
            textArea.value = copyText;
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            document.body.appendChild(textArea);
            textArea.select();
            try {
                document.execCommand('copy');
                // 显示成功状态
                copyWrapper.classList.add('copied');
                
                // 3秒后恢复原始状态
                setTimeout(function() {
                    copyWrapper.classList.remove('copied');
                }, 3000);
            } catch (err) {
            }
            document.body.removeChild(textArea);
        }
    });
});
